import { Api } from './../shared/config/api';
import { RequestService } from './../shared/service/request.service';
import { Observable } from 'rxjs/Rx';
import {AgentService} from '../shared/service/agent.service';
import {SessionService} from '../shared/service/session.service';
import {Component, OnInit, OnDestroy, ViewEncapsulation, AfterViewInit, ViewChild} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import * as $ from 'jquery';
import {Agent} from '../model/shared/user/user';
import { Alert, AlertType } from '../model/shared/alert';
import { AlertComponent } from './alert/alert.component';

@Component({
  selector: 'app-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AgentComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(AlertComponent)
  alertComponent: AlertComponent;

  _isLogin: Boolean = this.agentService._isLogin;
  _loginSubscription: Subject<boolean>;

  constructor(private _router: Router,
    private sessionService: SessionService,
    private requestService: RequestService,
    private agentService: AgentService) {
    this._loginSubscription = this.agentService._loginSubscription;
    this._loginSubscription.subscribe((value) => {
      this._isLogin = value;
    });

    $(window).resize(function() {
      const containerHeight = $('.agent-content-wrap').prop('scrollHeight');
      const topMenuHeight = $('.agent-menu-top-wrap').prop('scrollHeight');
      const applyHeight = containerHeight;
      // $('.agent-menu-left-container').height(applyHeight);
      // $('.popup-wrap').height(applyHeight + topMenuHeight);
      $('.popup-wrap').height($('html, body').prop('scrollHeight'));
    });

    $(document).ready(
      function() {
        const target = $('app-agent')[0];
        // create an observer instance
        const observer = new MutationObserver(function() {
          const containerHeight = $('.agent-content-wrap').prop('scrollHeight');
          const topMenuHeight = $('.agent-menu-top-wrap').prop('scrollHeight');
          const applyHeight = containerHeight;
          // $('.agent-menu-left-container').height(applyHeight);
          // $('.popup-wrap').height(applyHeight + topMenuHeight);
          $('.popup-wrap').height($('html, body').prop('scrollHeight'));

        });

        // configuration of the observer:
        const config = {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true
        };

        // pass in the target node, as well as the observer options
        observer.observe(target, config);
      }
    );

    _router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(function() {
          const containerHeight = $('.agent-content-wrap').prop('scrollHeight');
          const topMenuHeight = $('.agent-menu-top-wrap').prop('scrollHeight');
          const applyHeight = containerHeight;
          // $('.agent-menu-left-container').height(applyHeight);
          // $('.popup-wrap').height(applyHeight + topMenuHeight);
          $('.popup-wrap').height($('html, body').prop('scrollHeight'));
        }, 100);
      }
    });
  }

  get isLLP(): boolean {
    if (this.sessionService.getSession()) {
      const agent = new Agent();
      const sessionData = this.sessionService.getSession();
      if (!sessionData || (sessionData && sessionData.startsWith('{') === false)) {
        this.sessionService.clear();
        this.requestService._raw().get(Api.Common.sessionInit).subscribe();
        return;
      }
      Object.assign(agent, JSON.parse(this.sessionService.getSession()));
      if (agent.branch_code === 'LLP') {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  ngOnInit() {
    if (this._isLogin) {
      this._router.navigate(['/agent/home'], {replaceUrl: true});
    } else {
      this._router.navigate(['/agent/login'], {replaceUrl: true});
    }
  }
  ngOnDestroy(): void {
    this._loginSubscription.unsubscribe();
    return;
  }

  ngAfterViewInit(): void {
    const target = $('#tab-holder')[0];
    const separatorHeight = 2;
    // create an observer instance
    const observer = new MutationObserver(function() {

      const tabs = $(target).children();
      const separators = tabs.toArray().filter(val => $(val).height() === separatorHeight);
      let skip = 0 || separators.length;
      tabs.each((idx, val) => {
        if ($(val).height() === separatorHeight) {
          skip--;
          return;
        }
        const prev = tabs[idx - 1];

        if (separators.length > 0) {
          separators.forEach((_val, _idx, _arr) => {
            if (!$(_val).next().length) {
              $(_val).remove();
            }
          });
        }

        if (prev && skip <= 0) {
          if (Math.abs(val.offsetTop - prev.offsetTop) > 10) {
            $('<div style="height : ' + separatorHeight + 'px; background : #d8dbe0;"></div>').insertBefore(val);
          }
        }
      });
    });

    // configuration of the observer:
    const config = {
      childList: true,
      subtree: true,
    };

    // passing the target node and the observer options
    observer.observe(target, config);
  }

alertErrorCode (message, errorcode) {
    const alert: Alert = new Alert(AlertType.Alert, false);
    alert.ErrorCode = errorcode;
    alert.message = message;
    this.alertResponse(alert);
  }

  alert (message: string) {
    const alert: Alert = new Alert(AlertType.Alert, false);
    alert.message = message;
    this.alertResponse(alert);
  }

  alertDetail (message: string, emphasis: boolean) {
    const alert: Alert = new Alert(AlertType.Alert, emphasis);
    alert.message = message;
    this.alertResponse(alert);
  }

  alertResponse (data) {
    const alert: Alert = data;
    alert.type = AlertType.Alert;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
  }

  alertCallback (message: string, callback: () => void) {
    const alert: Alert = new Alert(AlertType.Alert, false);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setConfirmation(message, callback);
  }

  private subject = new Subject<any>();
  confirm(message: string, callback: (result: boolean) => void) {
    const alert: Alert = new Alert(AlertType.Confirm, false);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setConfirmation(message, callback);
  }

  confirmDetail(message: string, emphasis: boolean, callback: (result: boolean) => void) {
    const alert: Alert = new Alert(AlertType.Confirm, emphasis);
    alert.message = message;
    this.alertComponent.data = alert;
    this.alertComponent.show = true;
    this.alertComponent.confirm(this);
    this.setConfirmation(message, callback);
  }
  
  private setConfirmation(message: string, callback: (result: boolean) => void) {
    let that = this;
    this.subject.next({
      type: "confirm",
      text: message,
      yesFn:
        function () {
          that.subject.next(); //this will close the modal
          callback(true);
        },
      noFn: 
        function () {
          that.subject.next();
          callback(false);
        }
    });
  }

  getContainer(): Observable<any> {
    return this.subject.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/agent/agent.component.ts